import { useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '../../types';
import { useClientId } from './useClientId';
import { useFetchClient } from './useFetchClient';

export function useClient() {
  const { readClientIdFromUrlOrStorage } = useClientId();
  const clientId = readClientIdFromUrlOrStorage();
  const queryClient = useQueryClient();

  const { data: client, isLoading: clientLoading } = useFetchClient();

  const refetchClient = async () => {
    await queryClient.refetchQueries([QueryKey.Client, clientId]);
  };

  return {
    client,
    refetchClient,
    clientLoading: clientLoading && !!clientId,
    initialized: !clientId || !!client,
  };
}
